import { Box, Toolbar } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

export const MenuBar: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box>
      <Toolbar
        variant="dense"
        disableGutters={true}
        sx={{
          zIndex: 1,
          padding: "8px",
          display: "flex",
          minHeight: 56,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark"
              ? theme.palette.background.paper
              : theme.palette.background.default,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "none"
              : "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
          borderBottom: (theme) =>
            theme.palette.mode === "dark"
              ? "1px solid rgba(255, 255, 255, 0.06)"
              : "none",
        }}
      >
        {children}
      </Toolbar>
    </Box>
  );
};
